import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
export const ParticipationsStatusCard = ({ label, value }) => {
    return (React.createElement(Box, { sx: { height: '100%', p: 2, borderRadius: 0.5, backgroundColor: themeColors.surface.secondary } },
        React.createElement(Stack, { gap: 1 },
            React.createElement(Typography, { variant: 'subtitle2' }, label),
            React.createElement(Typography, { component: 'p', variant: 'h1' }, value))));
};
